<div class="card-container">
  <div class="icon-container">
    <mat-icon [svgIcon]="techServiceCardData?.icon"></mat-icon>
  </div>
  <div class="text-container">
    <span class="card-label">{{techServiceCardData?.serviceName}}</span>
    <div class="card-sub-labels">
      <span *ngIf="techServiceCardData.subLabel"
        class="card-sub-text1">{{techServiceCardData?.subLabel}}</span>
      <span class="card-text"> <button
          (click)="openModal.emit( techServiceCardData)"
          class="link link-primary-dark">{{techServiceCardData?.buttonLabel}}</button></span>
    </div>
  </div>
</div>